import React, { Component } from "react";
import PropTypes from "prop-types";
import ComponentScroll from "./ComponentScroll";
import Post from "./Post";
import { withStylesAndTranslation } from "../utils/container";

const styleSheet = theme => ({});

class PostScroll extends Component {
    static propTypes = {
        hasMore: PropTypes.bool.isRequired,
        edges: PropTypes.object.isRequired,
        loadMore: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired,
        onCorrectionButtonClick: PropTypes.func.isRequired,
        emptyStateMessage: PropTypes.string,
        currentUser: PropTypes.object.isRequired,
        onReactionButtonClick: PropTypes.func,
        onCorrectionReactionButtonClick: PropTypes.func,
        onSubmitComment: PropTypes.func,
        onMenuClick: PropTypes.func,
        onCorrectionMenuItemClick: PropTypes.func,
        t: PropTypes.func.isRequired
    };

    static defaultProps = {
        emptyStateMessage: "",
        onReactionButtonClick: () => {},
        onCorrectionReactionButtonClick: () => {},
        onSubmitComment: () => {},
        onMenuClick: () => {}
    };

    renderer = node => {
        const {
            onCorrectionButtonClick,
            currentUser,
            onReactionButtonClick,
            onCorrectionReactionButtonClick,
            onSubmitComment,
            onMenuClick,
            onCorrectionMenuItemClick
        } = this.props;
        return (
            <Post
                onMenuClick={onMenuClick}
                onSubmitComment={onSubmitComment}
                currentUser={currentUser}
                post={node}
                onCorrectionButtonClick={onCorrectionButtonClick(node)}
                onReactionButtonClick={onReactionButtonClick}
                onCorrectionReactionButtonClick={
                    onCorrectionReactionButtonClick
                }
                onCorrectionMenuItemClick={onCorrectionMenuItemClick}
            />
        );
    };

    render() {
        let { t, edges, loadMore, hasMore, emptyStateMessage } = this.props;

        if (!emptyStateMessage) {
            emptyStateMessage = t(emptyStateMessage);
        }
        return (
            <ComponentScroll
                emptyStateMessage={emptyStateMessage}
                edges={edges}
                renderComponent={this.renderer}
                loadMore={loadMore}
                hasMore={hasMore}
            />
        );
    }
}
export default withStylesAndTranslation(PostScroll, styleSheet);



// WEBPACK FOOTER //
// ./src/components/PostScroll.jsx